var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCode7(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 76,
    viewBox: "0 0 70 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2665 33.2665H0V0H33.2665V33.2665Z",
    fill: "#F1511B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9998 33.2665H36.7305V0H69.997V33.2665H69.9998Z",
    fill: "#80CC28"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2665 70.0107H0V36.7441H33.2665V70.0107Z",
    fill: "#00ADEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9998 70.0107H36.7305V36.7441H69.997V70.0107H69.9998Z",
    fill: "#FBBC09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode7);
export default __webpack_public_path__ + "static/media/code7.0a946896e9b62e59848110f89aabb677.svg";
export { ForwardRef as ReactComponent };